import * as types from './types';

const defaultNavigation = location => {
  if (typeof location === 'string') {
    return {
      replace: false,
      location: {
        pathname: location
      }
    };
  }
  return location.onSuccess;
};

const defaultNavigationError = location => {
  if (typeof location === 'string') {
    return null;
  }
  return location.onError ? location.Error : null;
};

const clearSaveError = () => ({
  type: types.SAVE_POSTING_DB_CLEAR_ERROR
});

const savePostingDB = (payload, location, saveAndExit, savedFromModal) => {
  const module = payload.module ? `?module=MODULE_${payload.module}` : '';
  const thenGo = !saveAndExit ? location : '/bum';
  return {
    type: types.SAVE_POSTING_DB,
    meta: {
      async: true,
      blocking: false,
      api: 'publicador',
      path: `/publicador/api/v1/postings/${payload.step}${module}`,
      body: payload.body,
      method: 'POST',
      saveAndExit,
      savedFromModal
    },
    navigateOnSuccess: defaultNavigation(thenGo),
    navigateOnError: defaultNavigationError(thenGo)
  };
};

export { savePostingDB, clearSaveError };
